(function () {
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var conn = navigator.connection || {};
  var allowAutoplay = function () { return !mqReduce.matches && !conn.saveData; };

  function play(v) {
    if (!v) return;
    v.muted = true; // iOS honors the property, not just the attribute
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
  function pause(v) { if (v && !v.paused) v.pause(); }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target._visible = entry.isIntersecting && entry.intersectionRatio > 0.2;
          if (entry.target._sync) entry.target._sync();
        });
      }, { threshold: [0, 0.2, 0.6] })
    : null;

  function init(el) {
    if (el.dataset.carouselInit) return;
    el.dataset.carouselInit = '1';

    var track  = el.querySelector('[data-card-carousel-track]');
    var slides = el.querySelectorAll('.card-carousel__slide');
    if (!slides.length) return;

    var prev = el.querySelector('[data-card-carousel-prev]');
    var next = el.querySelector('[data-card-carousel-next]');
    var dots = el.querySelectorAll('.card-carousel__dot');

    /* ===== Deferred slide images =====
       Slides 2+ are rendered with a 1px placeholder (see responsive-image.liquid,
       defer_load). Their real images are only downloaded once the shopper actually
       interacts with this card's carousel, so a collection page holds 1 image per
       card instead of 6-7. */
    var hydrated = false;
    var hydrate = function () {
      if (hydrated) return;
      hydrated = true;
      el.querySelectorAll('img[data-deferred-srcset]').forEach(function (img) {
        img.loading = 'eager';
        img.srcset = img.dataset.deferredSrcset;
        img.src = img.dataset.deferredSrc;
        img.removeAttribute('data-deferred-srcset');
        img.removeAttribute('data-deferred-src');
      });
    };

    var idx = function () {
      return (track && track.clientWidth) ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    };
    var go = function (i) {
      if (!track) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    };

    var sync = function () {
      var active = idx();
      var canPlay = allowAutoplay() && el._visible;
      slides.forEach(function (slide, i) {
        var v = slide.querySelector('[data-card-carousel-video]');
        if (!v) return;
        if (canPlay && i === active) { play(v); slide.classList.add('is-playing'); }
        else { pause(v); slide.classList.remove('is-playing'); }
      });
    };
    el._sync = sync;

    var update = function () {
      var i = idx();
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      if (prev) prev.hidden = i <= 0;
      if (next) next.hidden = i >= slides.length - 1;
      sync();
    };

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hydrate(); go(idx() - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hydrate(); go(idx() + 1); });

    if (slides.length > 1) {
      // Desktop: load the other slides when the mouse moves onto the card (arrows appear on hover).
      // Mouse only - on phones a finger touching a card while scrolling the page must NOT trigger this.
      el.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') hydrate();
      });
      // Keyboard users tabbing onto the arrows.
      el.addEventListener('focusin', hydrate);
    }

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        // Phones: the track only moves when the shopper swipes this card sideways.
        // (> 2px guard so scroll-snap settling on page load doesn't count as a swipe.)
        if (track.scrollLeft > 2) hydrate();
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
    }

    if (io) io.observe(el); else el._visible = true;
    update();
  }

  var all = function (root) { (root || document).querySelectorAll('[data-card-carousel]').forEach(init); };

  if (document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', function () { all(); });
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });

   if ('MutationObserver' in window) {
    var root = document.querySelector('#product-grid') || document.body; // use your grid's selector
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches('[data-card-carousel]')) init(n); // the added node itself
          all(n);                                         // carousels nested inside it
        });
        m.removedNodes.forEach(function (n) {
          if (n.nodeType !== 1 || !io) return;
          if (n.matches('[data-card-carousel]')) io.unobserve(n);
          n.querySelectorAll('[data-card-carousel]').forEach(function (el) { io.unobserve(el); });
        });
      });
    }).observe(root, { childList: true, subtree: true });
  }

  if (mqReduce.addEventListener) {
    mqReduce.addEventListener('change', function () {
      document.querySelectorAll('[data-card-carousel]').forEach(function (el) { if (el._sync) el._sync(); });
    });
  }
})();
